import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]查询理财首页定投专区
 */
export function queryFixedZoneUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultFixedZoneDto> {
  return resource.postNoAuth('/fixedZone/queryFixedZone', req, config);
}

/**
 * [No Auth]查询理财首页定投专区二级页面
 */
export function queryFixedZone2UsingPOST(req: void, config?: RequestConfig): Promise<ApiResultFixedZoneSecondDto> {
  return resource.postNoAuth('/fixedZone/queryFixedZone2', req, config);
}

/**
 * [No Auth]查询理财首页定投专区三级页面
 */
export function queryFixedZone3UsingPOST(
  req: FixedZoneDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultListFixedZoneThirdDto> {
  return resource.postNoAuth('/fixedZone/queryFixedZone3', req, config);
}
